<template>
    <section id="kids" class="o-section o-section-large">
        <h2 class="c-account__title o-title-5">
            <!-- <?php svg('account', '-ico-lg'); ?> -->
            <svg aria-hidden="true" focusable="false" class="o-ico -ico-lg">
                <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=cfe82883f6882d10e6#account"></use>
            </svg>
            Mes enfants
        </h2>
        <div v-if="result" class="c-block-success u-color-1-darker">
            <div class="c-block-success__inner">
                <div class="c-block-success__inner__icon">
                    <svg aria-hidden="true" focusable="false" class="o-ico ">
                        <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=cfe82883f6882d10e6#success"></use>
                    </svg>
                </div>
                <div class="o-text">
                    <p class="-is-text-large"><strong>Modification réussie</strong><br>Les informations de l'enfant ont été modifiées avec succès.</p>
                </div>
            </div>
        </div>
        <div v-for="(kid, index) in kids" :key="index" class="c-cart__item" :class="{'-is-open': kid.edit}">
            <div class="c-cart__item-header">                                   
                <div class="c-cart__product-name">
                    <h3 class="c-account-item__name">{{ kid.name }}</h3>
                </div>
                <div class="c-cart__product-btn__wrapper">
                    <button @click="editMember(index)" class="c-cart__product-btn-expend">
                        <!-- <?php svg('arrow-up-cart', '-icon-cart -icon-cart-arrow'); ?> -->
                        <svg aria-hidden="true" focusable="false" class="o-ico -icon-cart -icon-cart-arrow">
                            <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=5dea11d359b55f8dfd#arrow-up-cart"></use>
                        </svg>
                        <!-- <?php svg('inscription', '-icon-cart -icon-cart-edit'); ?> -->
                        <svg aria-hidden="true" focusable="false" class="o-ico -icon-cart -icon-cart-edit">
                            <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=5dea11d359b55f8dfd#inscription"></use>
                        </svg>
                    </button>
                </div>
            </div>
            <div v-if="kid.edit" class="c-cart__item-detail">
                <div class="c-cart__item-detail__inner">
                    <div class="c-cart-form">
                        <h4 class="o-title-5">Informations sur l'enfant</h4>
                        <form class="o-form " @submit.prevent="updateMember(index)">
                            <div class="o-form__row">
                                <div class="o-form__group">
                                    <input class="o-input" type="tel" id="secure" name="secure" :class="{'-input-filled' : kid.secure }" v-model="kid.secure">
                                    <label class="o-label" for="secure">Modifier le numéro d'assurance social</label>
                                </div>
                                <button class="c-cart__product-btn-delete" type="submit">
                                    <!-- <?php svg('trash', '-icon-cart'); ?> -->
                                    <svg aria-hidden="true" focusable="false" class="o-ico -icon-cart">
                                        <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=5dea11d359b55f8dfd#save"></use>
                                    </svg>
                                </button>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!kids || kids.length == 0" class="c-block-warning u-color-1-darker">
            <div class="c-block-warning__inner">
                <div class="c-block-warning__inner__icon">
                    <svg aria-hidden="true" focusable="false" class="o-ico ">
                        <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=cfe82883f6882d10e6#warning"></use>
                    </svg>
                </div>
                <div class="o-text">
                    <p class="-is-text-large"><strong>Aucun enfant</strong><br>Inscrit pour la prochaine année du Camp de jour.</p>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import axios from 'axios';
    import JSEncrypt from 'jsencrypt';

    export default {
        name: 'CustomerKids',
        props: {
            currentUser: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                kids: [],
                result: null
            }
        },
        created() {
            this.getKids()
        },
        methods: {
            getKids() {
                let params = {
                    _wpnonce: window.ajax_var.nonce,
                    rand: Math.random()
                }
                axios.get('/wp-json/cdj/v1/kids', { params })
                    .then(response => {
                        this.kids = response.data
                        for (let i = 0; i < this.kids.length; i++) {
                            this.kids[i].edit = false
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            editMember(index) {
                this.kids[index].edit = !this.kids[index].edit
            },
            updateMember(index) {
                let stereostore = document.getElementById('stereostore-plugin')
                let publicKey = stereostore.getAttribute('data-public-key')
                if(!publicKey) {
                    return
                }
                const rsa = new JSEncrypt();
                rsa.setPublicKey(publicKey);
                this.kids[index].secure = rsa.encrypt(this.kids[index].secure);

                let params = {
                    _wpnonce: window.ajax_var.nonce,
                    secure: this.kids[index].secure
                }
                axios.post('/wp-json/cdj/v1/kids/' + this.kids[index].id, params)
                    .then(response => {
                        console.log(response)
                        this.getKids()
                        //Show result 5 seconds
                        this.result = true
                        setTimeout(() => {
                            this.result = false
                        }, 5000)
                    })
                    .catch(error => {
                        console.log(error)
                    })
            }
        }
    }
</script>